<template>
  <div v-if="authReady" class="layout-wrapper">
    <app-top-header
      :publicPath="publicPath"
      :showHeader="showHeader"
      :currentUserRole="currentUserRole"
      :selectedHeader="selectedHeader"
      :headers="headers"
      :userModules="userModules"
      :currentUserRoles="currentUserRoles"
      :loggedinUserInfo="loggedinUserInfo"
      :userTenants="userTenants"
      :selectedTenantId="selectedTenantId"
      @tenant-change="handleTenantChange"
      @toggle-collapsed="collapsed = !collapsed"
      @goto-header="gotoHeader"
      @role-change="handleChange"
      @logout="logout"
    />
    <app-main-shell
      :showSidenav="showSidenav"
      :collapsed="collapsed"
      :gotPermissions="gotPermissions"
      :openKeys="openKeys"
      :selectedKeys="selectedKeys"
      :sidenavMenu="sidenavMenu"
      :loggedinUserPermissions="loggedinUserPermissions"
      @open-change="onOpenChange"
      @goto="goto"
      @goto-submenu="gotoSubMenu"
    />
    <a-layout-footer v-if="env === 'UAT'" class="text-right">
      <!-- OneTrust Cookies Settings button start -->
      <button id="ot-sdk-btn" class="ot-sdk-show-settings">Cookie Settings</button>
      <!-- OneTrust Cookies Settings button end -->
    </a-layout-footer>
    <!-- <ModalIdle v-if="isIdle" /> -->
  </div>
  <router-view />
  <app-privacy-modal
    :open="policyModal"
    :agreeLoading="agreeClickLoading"
    @agree="handleAgree"
    @close="handlepPlicyModalOk"
  />
</template>

<script>
import { defineComponent, reactive, toRefs, ref, onMounted } from 'vue'
import headers from './constants/header'
import sidenav from './constants/sidenav'
import userRoles from './constants/userRoles'
import NProgress from 'nprogress'
import { notification } from 'ant-design-vue';
import { authService } from './services/authService';
import { authEvents } from "./services/authService";
import microApps from './services/micro-app'
import AppTopHeader from './components/shared/AppTopHeader.vue'
import AppMainShell from './components/shared/AppMainShell.vue'
import AppPrivacyModal from './components/shared/AppPrivacyModal.vue'
import { Modal } from 'ant-design-vue'

export default defineComponent({
  setup() {
    const loggedInUser = ref(null)

    onMounted(async () => {
      loggedInUser.value = await authService.getUser();
    })
    const policyModal = ref(false);

    const handlepPlicyModalOk = () => {
      policyModal.value = false;
    };

    const gotPermissions = ref(false)
    const loggedinUserInfo = ref({})
    const userModules = ref([])
    const loggedinUserPermissions = ref([])
    const state = reactive({
      rootSubmenuKeys: sidenav.map(item => item.subName),
      openKeys: [window.location.pathname?.split('/')[2]],
      selectedKeys: [(window.location.pathname?.split('/')[3]) ? window.location.pathname?.split('/')[3] : window.location.pathname?.split('/')[1]],
      showSidenav: 'no',
      currentUserRoles: [],
      currentUserRole: '',
      userTenants: [],
      selectedTenantId: null
    })
    const onOpenChange = (openKeys) => {
      const latestOpenKey = openKeys.find(key => state.openKeys.indexOf(key) === -1)
      if (state.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
        state.openKeys = openKeys
      } else {
        state.openKeys = latestOpenKey ? [latestOpenKey] : []
        state.selectedKeys = []
      }
    }
    const noPermissionsNotification = (type, messgage, description) => {
      notification[type]({
        message: messgage,
        description: description
      });
    };
    const authReady = ref(false);
    
    const redisInfo = ref({});
    const permissions = ref([]);
    const modules = ref([]);
    const userRoles = ref([]);
    return {
      ...toRefs(state),
      onOpenChange,
      collapsed: ref(false),
      loggedinUserInfo,
      loggedinUserPermissions,
      gotPermissions,
      userModules,
      noPermissionsNotification,
      policyModal,
      handlepPlicyModalOk,
      agreeClickLoading: ref(false),
      showHeader: ref(true),
      env: ref(process.env.VUE_APP_Env),
      loggedInUser,
      ssoSubscription: null, 
      ssoFailedSubscription: null, 
      ssoExpiredSubscription: null, 
      authReady,
      redisInfo,
      permissions,
      modules,
      userRoles
    }
  },
  components: {
    AppTopHeader,
    AppMainShell,
    AppPrivacyModal,
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      headers,
      sidenav,
      current: '/dashboard/',
      selectedHeader: null,
      sidenavMenu: [],
      currentUserRoles: [],
      currentUserRole: '',
      roleChange: false,
      userTenants: [],
      selectedTenantId: null
    }
  },
  methods: {
    resolveStandaloneUrl(path) {
      const normalizedPath = path.startsWith('/') ? path : `/${path}`
      const matchedApp = [...microApps]
        .sort((a, b) => b.activeRule.length - a.activeRule.length)
        .find((app) => normalizedPath === app.activeRule || normalizedPath.startsWith(`${app.activeRule}/`))

      if (!matchedApp || !matchedApp.entry) {
        return null
      }

      const normalizedEntry = matchedApp.entry.endsWith('/') ? matchedApp.entry.slice(0, -1) : matchedApp.entry
      return `${normalizedEntry}${normalizedPath}`
    },
    navigateTo(path) {
      if (sessionStorage.getItem('QIANKUN_DISABLED') === 'true') {
        const standaloneUrl = this.resolveStandaloneUrl(path)
        if (standaloneUrl) {
          window.location.assign(standaloneUrl)
          return
        }
      }

      history.pushState(null, path, path)
    },
    goto(item) {
      this.navigateTo(item.activeRule)
      this.selectedKeys = [item.subName]
      this.openKeys = []
    },
    gotoSubMenu(item) {
      this.navigateTo(item.activeRule)
      this.selectedKeys = [item.subName]
    },
    handleChange(value) {
      this.showHeader = false
      const oldRoleId = sessionStorage.getItem('roleId');
      sessionStorage.setItem('roleId', value)
      this.currentUserRole = sessionStorage.getItem('roleId')
      NProgress.start()
      this.roleChange = true;
      fetch(`${process.env.VUE_APP_apiGatewayRestURL}api/administration/rolepermissions/byroleid?id=${sessionStorage.getItem('roleId')}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + sessionStorage.getItem('token')
        }
      })
        .then(response => response.json())
        .then(userPermission => {
          const permissions = userPermission.permissions
          if((permissions && permissions.length == 0) || permissions[0] == ''){
            sessionStorage.setItem('roleId', oldRoleId)
            this.currentUserRole = oldRoleId;
            this.noPermissionsNotification('error', 'Access Restricted', 'No any permissions are availble to accees, Please contact with admin')
            NProgress.done()
            return
          }
          const modules = userPermission.modules
          sessionStorage.setItem('UserPermissions', JSON.stringify(permissions))
          sessionStorage.setItem('UserModules', JSON.stringify(modules))
          NProgress.done()
          this.permissions = JSON.parse(sessionStorage.getItem('UserPermissions') || '[]')
          this.modules     = JSON.parse(sessionStorage.getItem('UserModules') || '[]')          
          this.handlePostAuthenticate(this.redisInfo, this.permissions, this.modules, this.userRoles)
        })
    },  
    handleTenantChange(value){      
      this.selectedTenantId = value; 
      const oidcUserData = sessionStorage.getItem('OIDC_USER');
          let email = '';
          if (oidcUserData) {
              const oidcUser = JSON.parse(oidcUserData);
              email = oidcUser?.profile?.preferred_username ?? '';
          }
      fetch(`${process.env.VUE_APP_apiGatewayRestURL}api/administration/user/verifyactivetenant?selectedTenantId=${this.selectedTenantId}&email=${email}`, 
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + this.loggedInUser.access_token
        }
      })
      .then(response => response.json())
      .then(response => {
        if(response.isTenantActive){
          sessionStorage.clear();
          window.location.href =
          `${process.env.VUE_APP_authority}/TenentSwitch?tenantId=${this.selectedTenantId}&ClientId=${process.env.VUE_APP_clientId}`;
        }
        else{
          this.userTenants = response.userTenants;
          sessionStorage.setItem('userTenants', JSON.stringify(response.userTenants));
          Modal.info({
                    title: "Tenant Unavailable",
                    content: "The selected tenant has been deactivated. Please select another tenant.",
                    okText: "Ok",
                    maskClosable: false,
                    closable: false,
                    centered: true,
                    keyboard: false
                });
        }        
      })
      .catch(error => {
        console.log(error)
      }) 
    }, 
    onDropdownVisibleChange(){
      this.userTenants = JSON.parse(sessionStorage.getItem('userTenants'));
      if(this.userTenants && this.userTenants.length > 0){
        const currentTenantData = this.userTenants?.find(x => x.tenantName == this.loggedinUserInfo?.tenantName);
        this.selectedTenantId = currentTenantData?.tenantID;
      }
      
      if(!this.userTenants || this.userTenants.length === 0){
          const oidcUserData = sessionStorage.getItem('OIDC_USER');
          let email = '';
          if (oidcUserData) {
              const oidcUser = JSON.parse(oidcUserData);
              email = oidcUser?.profile?.preferred_username ?? '';
          }
          fetch(`${process.env.VUE_APP_apiGatewayRestURL}api/administration/user/gettenantusers?email=${email}`, {
                    method: 'GET',
                    headers: {
                      'Content-Type': 'application/json',
                      Authorization: 'Bearer ' + this.loggedInUser.access_token
                    }
                  })
                  .then(response => response.json())
                  .then(response => {
                    this.userTenants = response;
                    sessionStorage.setItem('userTenants', JSON.stringify(response));
                    const currentTenantData = this.userTenants.find(x => x.tenantName == this.loggedinUserInfo?.tenantName);
                    this.selectedTenantId = currentTenantData?.tenantID;
                  })
                  .catch(error => {
                    console.log(error)
                  })
      }
      sessionStorage.setItem('identityServiceUrl', process.env.VUE_APP_authority);
    },
    handleAgree() {
      this.agreeClickLoading = true
      fetch(`${process.env.VUE_APP_apiGatewayRestURL}api/administration/privacy?action=UPDATE`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + this.loggedInUser.access_token
        }
      })
        .then(response => response.json())
        .then(() => {
          this.policyModal = false
          this.agreeClickLoading = false
        })
        .catch(() => {
          this.agreeClickLoading = false
        })
    },
    gotoHeader(item) {
      sessionStorage.removeItem('qs_embed');
      if (this.currentUserRole === userRoles.Checker) {
        this.selectedHeader = item.subName
        if (item.name === 'TDS') {
          sessionStorage.setItem('selectedModule', 'TDS')
          sessionStorage.setItem('urlModuleName', 'tds')
          this.navigateTo('/tds/liability/approval/liability')
        } else {
          sessionStorage.setItem('selectedModule', 'TCS')
          sessionStorage.setItem('urlModuleName', 'tcs')
          this.navigateTo('/tcs/liability/approval/liability')
        }
      }
      else {
        this.selectedHeader = item.subName
        // if (item.subName !== 'dashboard') {
          this.openKeys = [item.activeRule.split('/')[2]]
          this.selectedKeys = [item.activeRule.split('/')[3]]
        // }
        const moduleName = this.selectedHeader
        sessionStorage.setItem('urlModuleName', moduleName)
        sessionStorage.setItem('selectedModule', this.selectedHeader?.toUpperCase())
        this.sidenavMenu = this.sidenav.find((item) => { return item.moduleName === moduleName })?.menu
        for (let i = 0; i < this.sidenavMenu.length; i++) {
          if (this.loggedinUserPermissions?.indexOf(this.sidenavMenu[i].permission) > -1) {
            if(this.sidenavMenu[i].permission == 'DASHBOARD'){
                this.navigateTo(this.sidenavMenu[i].activeRule)
                break
            } else {
              if (this.sidenavMenu[i].children) {
                for (let j = 0; j < this.sidenavMenu[i].children.length; j++) {
                  if (this.loggedinUserPermissions?.indexOf(this.sidenavMenu[i].children[j].permission) > -1) {
                    this.navigateTo(this.sidenavMenu[i].children[j].activeRule)
                    break
                  }
                }
                break
              } else {
                this.navigateTo(this.sidenavMenu[i].activeRule)
                break
              }
            }
          }
        }
        this.bindCurrent()
      }
    },
    logout() {
      this.authReady = false;
      sessionStorage.clear();
      authService.signout();
    },
    onWindowLoad() {
      if(sessionStorage.getItem('LoggedinUserId') && this.env === 'UAT') {
        this.loadCookiesScript()
      }
    },
    bindCurrent() {
      const path = window.location.pathname
      const pathSegments = path.split('/');      
      if (String(sessionStorage.getItem('roleId')) === userRoles.Checker || pathSegments[1] == 'dashboard') {
        this.showSidenav = 'no'
        if(pathSegments[1] == 'dashboard'){
          this.selectedHeader = pathSegments[1]?.toLowerCase();
        }
      } else {
        this.showSidenav = 'yes'
        if (pathSegments[2] == 'masters') {
          console.log(pathSegments)
          if (pathSegments[3] == 'tracker') {
            this.openKeys = [pathSegments[3]]
            this.selectedKeys = [pathSegments[4]]
            this.selectedHeader = pathSegments[1]?.toLowerCase();
          } else {
            this.openKeys = [pathSegments[2]]
            this.selectedKeys = [pathSegments[3]]
            this.selectedHeader = pathSegments[1]?.toLowerCase();
          }
        } else if (pathSegments[1] == 'compliances') {
          this.openKeys = [pathSegments[1]]
          this.selectedKeys = [pathSegments[3]]
          this.selectedHeader = pathSegments[2]?.toLowerCase();
        } else if (pathSegments[1] == 'onboarding') {
          this.openKeys = []
          this.selectedKeys = [pathSegments[1]]
          this.selectedHeader = pathSegments[1]?.toLowerCase();
        } else if (pathSegments[1] == 'administration') {
          this.openKeys = []
          this.selectedKeys = [pathSegments[2] == 'settings' ? pathSegments[2] : pathSegments[1]]
          this.selectedHeader = sessionStorage.getItem('urlModuleName')
        } else if (pathSegments[1] == 'masters') {
          this.openKeys = [pathSegments[1]]
          this.selectedKeys = [pathSegments[3]]
          this.selectedHeader = pathSegments[1]?.toLowerCase();
        } else if (pathSegments[1] == 'dashboard') {
          this.openKeys = [pathSegments[2]]
          this.selectedKeys = [pathSegments[3]]
          this.selectedHeader = pathSegments[1]?.toLowerCase();
        }  else {
          this.openKeys = []
          this.selectedKeys = [pathSegments[2]]
          this.selectedHeader = pathSegments[1]?.toLowerCase();
        }
      }
      sessionStorage.setItem('urlModuleName', this.selectedHeader)
      sessionStorage.setItem('selectedModule', this.selectedHeader?.toUpperCase())

      if (sessionStorage.getItem('roleId') === userRoles.SuperAdmin) {
        this.sidenavMenu = this.sidenav.find((item) => { return item.moduleId === 6 })?.menu
      } else if (sessionStorage.getItem('roleId') === userRoles.Checker) {
        this.sidenavMenu = this.sidenav.find((item) => { return item.moduleId === 5 })?.menu
        this.userModules = this.userModules.filter(item => item !== 'Dashboard' && item !== 'Form 26 AS');
      } else {
        this.sidenavMenu = this.sidenav.find((item) => { return item.moduleName === this.selectedHeader })?.menu
      }
    },
    listenRouterChange() {
      const _wr = function (type) {
        const orig = history[type]
        return function () {
          const rv = orig.apply(this, arguments)
          const e = new Event(type)
          e.arguments = arguments
          window.dispatchEvent(e)
          return rv
        }
      }
      history.pushState = _wr('pushState')

      window.addEventListener('popstate', this.bindCurrent)
      window.addEventListener('load', this.onWindowLoad)
    },
    async handlePreLogin(){
      if (this.env === 'UAT') {
        this.loadCookiesScript()
      }
      if (this.loggedInUser) {
        if (!sessionStorage.getItem('LoggedinUserId')) {
          if (sessionStorage.getItem('roleId') === '1') {
            await this.applySuperAdminDefaults();
          }         
          this.handlePostAuthenticate(this.redisInfo, this.permissions, this.modules, this.userRoles)
        } else {
          if (window.location.pathname === '/') {
            if (sessionStorage.getItem('roleId') === '1') {
              await this.applySuperAdminDefaults();
            } 
            this.handlePostAuthenticate(this.redisInfo, this.permissions, this.modules, this.userRoles)
          } else {
            this.currentUserRole = sessionStorage.getItem('roleId')
            if (this.currentUserRole === userRoles.Checker) {
              this.showSidenav = 'no'
            }
            this.handlePostAuthenticate(this.redisInfo, this.permissions, this.modules, this.userRoles)
          }
        }
      }
    },
    async applySuperAdminDefaults() {
      const permissions = ['ADMIN_CLIENT_ONBOARDING', 'ADMIN_MASTERS', 'ADMIN_TDS_SECTION', 'ADMIN_TCS_SECTION', 'ADMIN_REASONING']
      const modules = ['SuperAdmin']
      sessionStorage.setItem('UserPermissions', JSON.stringify(permissions))
      sessionStorage.setItem('UserModules', JSON.stringify(modules))
      return true;
    },
    handlePostAuthenticate(redisInfo, permissions, modules, currenUserRoles) {
      this.showHeader = true
      sessionStorage.setItem('apiGatewayRestURL', process.env.VUE_APP_apiGatewayRestURL);
      this.loggedinUserInfo = redisInfo
      this.loggedinUserPermissions = permissions
      this.gotPermissions = true
      this.currentUserRole = sessionStorage.getItem('roleId')
      if (this.currentUserRole === userRoles.Checker) {
        this.showSidenav = 'no'
      } else {
        this.showSidenav = 'yes'
      }
      this.currentUserRoles = currenUserRoles
      this.userModules = modules
      if ((this.userModules && this.userModules.length > 0 && window.location.pathname === '/') || this.roleChange) {
        this.roleChange = false;
        if (this.currentUserRole === userRoles.Checker) {
          this.userModules = this.userModules.filter(item => item !== 'Dashboard' && item !== 'Form 26 AS');
          this.sidenavMenu = this.sidenav.find((item) => { return item.moduleId === 5 })?.menu
          
          this.selectedHeader = this.userModules[0].toLowerCase();
          if (this.selectedHeader === 'tds') {
            sessionStorage.setItem('selectedModule', 'TDS')
            sessionStorage.setItem('urlModuleName', 'tds')
            this.navigateTo('/tds/liability/approval/liability')
          } else {
            sessionStorage.setItem('selectedModule', 'TCS')
            sessionStorage.setItem('urlModuleName', 'tcs')
            this.navigateTo('/tcs/liability/approval/liability')
          }
        } else if (sessionStorage.getItem('roleId') === '1') {
          this.sidenavMenu = this.sidenav.find((item) => { return item.moduleId === 6 })?.menu
          this.navigateTo(this.sidenavMenu[0].activeRule)
        } else {
          const moduleName = ((this.userModules[0] === 'Form 26 AS') ? 'form26as' : (this.userModules[0] === 'Clause 34 Reconciliation') ? 'clause34' : this.userModules[0]).toLowerCase()
          sessionStorage.setItem('urlModuleName', moduleName)
          this.selectedHeader = moduleName
          this.sidenavMenu = this.sidenav.find((item) => { return item.moduleName === moduleName })?.menu
          for (let i = 0; i < this.sidenavMenu.length; i++) {
            if (this.loggedinUserPermissions?.indexOf(this.sidenavMenu[i].permission) > -1) {
              if(this.sidenavMenu[i].permission == 'DASHBOARD'){
                  this.navigateTo(this.sidenavMenu[i].activeRule)
                  break
              } else {
                if (this.sidenavMenu[i].children) {
                  for (let j = 0; j < this.sidenavMenu[i].children.length; j++) {
                    if (this.loggedinUserPermissions?.indexOf(this.sidenavMenu[i].children[j].permission) > -1) {
                      this.navigateTo(this.sidenavMenu[i].children[j].activeRule)
                      break
                    }
                  }
                  break
                } else {
                  this.navigateTo(this.sidenavMenu[i].activeRule)
                  break
                }
              }
            }
          }
        }
        sessionStorage.setItem('selectedModule', this.selectedHeader?.toUpperCase())
        this.bindCurrent();
      } else {
        this.bindCurrent();
      }
        setTimeout(() => {
          if (sessionStorage.getItem('roleId') != userRoles.SuperAdmin) {
          fetch(`${process.env.VUE_APP_apiGatewayRestURL}api/administration/privacy?action=GET`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + this.loggedInUser.access_token
            }
          })
            .then(response => response.json())
            .then(response => {
              if(response){
                this.policyModal = true;
              }
            })
        }
        this.onDropdownVisibleChange();
        }, 5000);
    },
    loadCookiesScript() {
      let recaptchaScript = document.createElement('script')
      recaptchaScript.setAttribute('src', '/vendor/otSDKStub.js')
      recaptchaScript.setAttribute('type', 'text/javascript')
      recaptchaScript.setAttribute('charset', 'UTF-8')
      recaptchaScript.setAttribute('data-domain-script', 'e463c141-d6e5-43d0-a25e-a672f2a4139d')
      document.head.appendChild(recaptchaScript)
    }    
  },
  created() {
    this.bindCurrent()
  },
  beforeUnmount () {
    this.ssoSubscription?.();
    this.ssoFailedSubscription?.();
    this.ssoExpiredSubscription?.();
  },
  mounted() {
    sessionStorage.setItem('taxPortalAPIEndPointUrl', process.env.VUE_APP_taxPortalAPIEndPointUrl);
    this.listenRouterChange();

    const loadAuthData = () => {
      this.redisInfo   = JSON.parse(sessionStorage.getItem('UserInfo') || '{}')
      this.permissions = JSON.parse(sessionStorage.getItem('UserPermissions') || '[]')
      this.modules     = JSON.parse(sessionStorage.getItem('UserModules') || '[]')
      this.userRoles   = JSON.parse(sessionStorage.getItem('userRoles') || '[]')
      this.loggedInUser = JSON.parse(sessionStorage.getItem('OIDC_USER') || 'null')
      this.authReady = true;

      this.modules = this.modules.includes('Dashboard')
        ? ['Dashboard', ...this.modules.filter(i => i !== 'Dashboard')]
        : this.modules;
      this.handlePreLogin()
    }
    
    // Listen for async SSO events first
    this.ssoSubscription = authEvents.on("silentSSO-success", (user) => {
      this.authReady = true;
      this.loggedInUser = user;
      sessionStorage.setItem('token', user.access_token)
      sessionStorage.setItem('id_token', user.id_token)
      sessionStorage.setItem('OIDC_USER', JSON.stringify(user))
    });

    this.ssoFailedSubscription = authEvents.on("silentSSO-failed", () => {
      authService.signinRedirect();
    });

    this.ssoExpiredSubscription = authEvents.on("session-expired", () => {
      authService.signinRedirect();
    });

    if (sessionStorage.getItem('AUTH_READY') === 'true') {
      loadAuthData()
    } else {
      window.addEventListener('auth-ready', loadAuthData, { once: true })
    }
  }
})
</script>
